import { writable } from '../external_node_modules/svelte/store/index.mjs.js';
import { EVENTS } from '../constants/events.js';
import events from '../core/event/index.js';

const tsv = {
    accountStatus: '',
    method: '',
    mandatoryCheck: null,
    managementUrl: '',
};
const { subscribe, update } = writable(tsv);
function setTsv(tsv) {
    return update((state) => {
        state = tsv;
        events.emit(EVENTS.TSV_MANAGEMENT_URL, { managementUrl: state.managementUrl });
        events.emit(EVENTS.SET_TSV, { tsv });
        return state;
    });
}
var tsv$1 = {
    subscribe,
};

export { tsv$1 as default, setTsv };
//# sourceMappingURL=tsv.js.map
